import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'
import { MyLocation } from '@workwave-tidal/core/icons/MyLocation'
import React from 'react'
import { useLocateMe } from './hooks'
import maplibregl from 'maplibre-gl'
import { MutableRefObject } from 'react'

type Props = {
  hereMap: H.Map | undefined
  mlMap?: maplibregl.Map | null
  lastKnownPositionRef?: MutableRefObject<{ lat: number; lng: number } | null>
}

export function LocateMeButton({
  hereMap,
  mlMap,
  lastKnownPositionRef,
}: Props) {
  const { locateMe } = useLocateMe({
    map: hereMap,
    mlMap,
    lastKnownPositionRef,
  })
  return (
    <Paper elevation={4}>
      <Stack>
        <IconButton sx={{ p: 1 }} onClick={locateMe}>
          <MyLocation fontSize="small" />
        </IconButton>
      </Stack>
    </Paper>
  )
}
